import React from "react"
import Components from "../components/components"

export const createElement = (blok, teasers) => {
  let components = []
  let blokBody = teasers || blok.body
  {
    blokBody &&
      blokBody.map((blokItem) => {
        let languageSelected = blokItem.componentVisibility || []
        let component
        if (
          languageSelected.length === 0 ||
          languageSelected.includes(blok.currentLanguage)
        ) {
          component = React.createElement(Components(blokItem.component), {
            key: blokItem._uid,
            blok: {
              ...blokItem,
              pageLocation: blok.location,
              currentLanguage: blok.currentLanguage,
            },
          })
        }
        return components.push(component)
      })
  }
  return components
}
